import { IUser } from "./typesUser";

export interface ITitular {
  nombre: string;
  apellido: string;
}

export interface ITitularJuridico {
  nombreEmpresa: string;
}

export enum TipoInforme {
  BienesPersonalesCapitalFisica = "BienesPersonalesCapitalFisica",
  BienesPersonalesCapitalJuridica = "BienesPersonalesCapitalJuridica",
  CopiaDeEscrituraYReglamentos = "CopiaDeEscrituraYReglamentos",
  DominioCapitalModerno = "DominioCapitalModerno",
  DominioCapitalAntiguo = "DominioCapitalAntiguo",
  EmpresarialCapitalFisica = "EmpresarialCapitalFisica",
  EmpresarialCapitalJuridica = "EmpresarialCapitalJuridica",
  FrecuenciaCapital = "FrecuenciaCapital",
  InhibicionCapitalFisica = "InhibicionCapitalFisica",
  InhibicionCapitalJuridica = "InhibicionCapitalJuridica",
  TitularidadCapital = "TitularidadCapital",
  TitularidadDominioCapital = "TitularidadDominioCapital",
  ConsultaIndiceTitularesProvinciaFisica = "ConsultaIndiceTitularesProvinciaFisica",
  ConsultaIndiceTitularesProvinciaJuridica = "ConsultaIndiceTitularesProvinciaJuridica",
  CesionProvinciaFisica = "CesionProvinciaFisica",
  CesionProvinciaJuridica = "CesionProvinciaJuridica",
  CopiaDeEscrituraYReglamentosProvincia = "CopiaDeEscrituraYReglamentosProvincia",
  EmpresarialProvinciaFisica = "EmpresarialProvinciaFisica",
  EmpresarialProvinciaJuridica = "EmpresarialProvinciaJuridica",
  FrecuenciaProvincia = "FrecuenciaProvincia",
  InhibicionProvinciaFisica = "InhibicionProvinciaFisica",
  InhibicionProvinciaJuridica = "InhibicionProvinciaJuridica",
  PlanoObraSanitariaCapitalCatastro = "PlanoObraSanitariaCapitalCatastro",
  PlanoMensuraSubdivicionCapital = "PlanoMensuraSubdivicionCapital",
  PartidaNacimiento = "PartidaNacimiento",
  PartidaMatrimonio = "PartidaMatrimonio",
  PartidaUnionConvivencial = "PartidaUnionConvivencial",
  PartidaDefuncion = "PartidaDefuncion",
  DominioAutomotor = "DominioAutomotor",
  InhibicionAutomotorFisica = "InhibicionAutomotor",
  InhibicionAutomotorJuridica = "InhibicionAutomotorJuridica",
  Transferencia = "Transferencia",
  Patentamiento = "Patentamiento",
  EstadoParcelarioCapitalCatastro = "EstadoParcelarioCapitalCatastro",
  EstudioPrefectibilidadCapitalCatastro = "EstudioPrefectibilidadCapitalCatastro",
  EstadoParcelarioProvinciaCatastro = "EstadoParcelarioProvinciaCatastro",
  EstudioPrefectibilidadProvinciaCatastro = "EstudioPrefectibilidadProvinciaCatastro",
  DominioProvinciaMatriculado = "DominioProvinciaMatriculado",
  DominioProvinciaNoMatriculado = "DominioProvinciaNoMatriculado",
  PlanchetaCapital = "PlanchetaCapital",
  ValuacionFiscalCapital = "ValuacionFiscalCapital",
  PlanoMensuraSubdivicionProvincia = "PlanoMensuraSubdivicionProvincia",
  CedulaCatastralProvincia = "CedulaCatastralProvincia",
  CertificadoCatastralP = "CertificadoCatastralP",
  PlanoObraCapital = "PlanoObraCapital",
  CedulaCatastralOtrosTramitesP = "CedulaCatastralOtrosTramitesP",
  PlanchetaDistribucionParcelariaP = "PlanchetaDistribucionParcelariaP",
  ValuacionFiscalP = "ValuacionFiscalP",
  InscripcionOficiosPoC = "InscripcionOficiosPoC",
  InformeGeneralInterior = "InformeGeneralInterior",
}


export const DicTipoInformeEspecificoTablaPrecios: { [key: string]: string } = {
  // Capital (Están todos)
  "BienesPersonalesCapital": "Bienes Personales Capital",
  "CopiaEscrituraReglamentoCapital": "Copia de Escritura o Reglamentos Capital",
  "DominioCapital": "Dominio Capital",
  "EmpresarialCapital": "Empresarial Capital",
  "FrecuenciaCapital": "Frecuencia Capital",
  "InhibicionCapital": "Inhibición Capital",
  "TitularidadCapital": "Titularidad Capital",
  "TitularidadDominioCapital": "4B",

  // Provincia (Están todos)
  "ConsultaIndiceTitularesProvincia": "Consulta al índice de Titulares Provincia",
  "CesionProvincia": "Cesión Provincia",
  "CopiaDeEscrituraYReglamentosProvincia": "Copia de Escritura o Reglamentos Provincia",
  "EmpresarialProvincia": "Empresarial Provincia",
  "FrecuenciaProvincia": "Frecuencia Provincia",
  "InhibicionProvincia": "Inhibición Provincia",

  // Catastro Capital CopiaDePlanos (Están todas)
  "PlanoObraSanitariaCapital": "Obras Sanitarias (AySa)",

  // Partidas (Están todas)
  "PartidaDefuncion": "Partida de Defunción",
  "PartidaMatrimonio": "Partida de Matrimonio",
  "PartidaNacimiento": "Partida de Nacimiento",
  "PartidaUnionConvivencial": "Partida de Unión Convivencial",

  // Automotor (Están todas)
  "DominioAutomotor": "Dominio Automotor",
  "InhibicionAutomotor": "Inhibición Automotor",

  // Transferencias (Están todas)
  "Transferencia": "Transferencia",

  // Patentamientos (Están todas)
  "Patentamiento": "Patentamiento",

  // Catastro Capital Plancheta (Están todas)
  "EstadoParcelarioCapital": "Estado Parcelario Capital Catastro",
  "EstudioPrefectibilidadCapital": "Estudio de Prefactibilidad Capital Catastro",

  // Catastro Provincia Plancheta (Están todas)
  "EstadoParcelarioProvincia": "Estado Parcelario Provincia Catastro",
  "EstudioPrefectibilidadProvincia": "Estudio de Prefectibilidad Provincia Catastro",

  // Informes con nomenclatura catastral Provincia (Están todas)
  "DominioProvinciaMatriculado": "Dominio Provincia Matriculado",
  "DominioProvinciaNoMatriculado": "Dominio Provincia No Matriculado",

  // Catastro Provincia Plancheta (Están todas)
  "PlanchetaCapital": "Plancheta Capital",
  "ValuacionFiscalCapital": "Valuación Fiscal Capital",

  // Catastro Provincia CopiaDePlanos (Están todas)
  "PlanoMensuraSubdivicionCapital": "Plano Mensura Subdivisión Capital",
  "PlanoMensuraSubdivicionProvincia": "Plano Mensura Subdivisión Provincia",

  // Catastro Capital CopiaDePlanos (Están todas)
  "PlanoObraCapital": "Plano Obra Capital",

  // Otros Tramites Servicios Para Abogados (Están todas)
  "CedulaCatastralProvincia": "Cédula Catastral Otros Trámites Provincia",
  "CertificadoCatastralProvincia": "Certificado Catastral Provincia",
  "PlanchetaDistribucionParcelariaProvincia": "Plancheta Distribución Parcelaria Provincia",
  "ValuacionFiscalProvincia": "Valuación Fiscal Provincia",
  "InscripcionOficiosProvinciaCapital": "Inscripción de Oficios Capital",
  "InformeGeneralInterior": "Informes del Interior del país",

}

export const TipoInformeNameResolver = {
  [TipoInforme.BienesPersonalesCapitalFisica]: "Informe de Bienes Personales Capital (Física)",
  [TipoInforme.BienesPersonalesCapitalJuridica]: "Informe de Bienes Personales Capital (Jurídica)",
  [TipoInforme.CopiaDeEscrituraYReglamentos]: "Informe de Copia de Escritura o Reglamentos",
  [TipoInforme.DominioCapitalModerno]: "Informe de Dominio Capital",
  [TipoInforme.DominioCapitalAntiguo]: "Informe de Dominio Capital",
  [TipoInforme.EmpresarialCapitalFisica]: "Informe Empresarial Capital (Física)",
  [TipoInforme.EmpresarialCapitalJuridica]: "Informe Empresarial Capital (Jurídica)",
  [TipoInforme.FrecuenciaCapital]: "Informe de Frecuencia Capital",
  [TipoInforme.InhibicionCapitalFisica]: "Informe de Inhibición Capital (Física)",
  [TipoInforme.InhibicionCapitalJuridica]: "Informe de Inhibición Capital (Jurídica)",
  [TipoInforme.TitularidadCapital]: "Informe de Titularidad Capital",
  [TipoInforme.DominioProvinciaMatriculado]: "Informe de Dominio Provincia (Matriculado)",
  [TipoInforme.DominioProvinciaNoMatriculado]: "Informe de Dominio Provincia (No Matriculado)",
  [TipoInforme.CopiaDeEscrituraYReglamentosProvincia]: "Informe de Copia de Escritura o Reglamentos (Provincia)",
  [TipoInforme.EmpresarialProvinciaFisica]: "Informe Empresarial Provincia (Física)",
  [TipoInforme.EmpresarialProvinciaJuridica]: "Informe Empresarial Provincia (Jurídica)",
  [TipoInforme.FrecuenciaProvincia]: "Informe de Frecuencia Provincia",
  [TipoInforme.InhibicionProvinciaFisica]: "Informe de Inhibición Provincia (Física)",
  [TipoInforme.InhibicionProvinciaJuridica]: "Informe de Inhibición Provincia (Jurídica)",
  [TipoInforme.PlanoObraSanitariaCapitalCatastro]: "Informe de Plano Obra Sanitaria Capital (Catastro)",
  [TipoInforme.PlanoMensuraSubdivicionCapital]: "Informe de Plano Mensura Subdivisión Capital",
  [TipoInforme.PartidaNacimiento]: "Informe de Partida de Nacimiento",
  [TipoInforme.PartidaMatrimonio]: "Informe de Partida de Matrimonio",
  [TipoInforme.PartidaUnionConvivencial]: "Informe de Partida de Unión Convivencial",
  [TipoInforme.PartidaDefuncion]: "Informe de Partida de Defunción",
  [TipoInforme.DominioAutomotor]: "Informe de Dominio Automotor",
  [TipoInforme.InhibicionAutomotorFisica]: "Informe de Inhibición Automotor (Física)",
  [TipoInforme.InhibicionAutomotorJuridica]: "Informe de Inhibición Automotor (Juridica)",
  [TipoInforme.Transferencia]: "Informe de Transferencia",
  [TipoInforme.Patentamiento]: "Informe de Patentamiento",
  [TipoInforme.EstadoParcelarioCapitalCatastro]: "Informe de Estado Parcelario Capital (Catastro)",
  [TipoInforme.EstudioPrefectibilidadCapitalCatastro]: "Informe de Estudio de Prefactibilidad Capital (Catastro)",
  [TipoInforme.EstadoParcelarioProvinciaCatastro]: "Informe de Estado Parcelario Provincia (Catastro)",
  [TipoInforme.EstudioPrefectibilidadProvinciaCatastro]: "Informe de Estudio de Prefectibilidad Provincia (Catastro)",
  [TipoInforme.PlanchetaCapital]: "Informe de Plancheta Capital",
  [TipoInforme.ValuacionFiscalCapital]: "Informe de Valuación Fiscal Capital",
  [TipoInforme.PlanoMensuraSubdivicionProvincia]: "Informe de Plano Mensura Subdivisión Provincia",
  [TipoInforme.CedulaCatastralProvincia]: "Informe de Cédula Catastral Provincia",
  [TipoInforme.PlanoObraCapital]: "Informe de Plano Obra Capital",
  [TipoInforme.CedulaCatastralOtrosTramitesP]: "Informe de Cédula Catastral Otros Trámites (P)",
  [TipoInforme.CertificadoCatastralP]: "Informe de Certificado Catastral (P)",
  [TipoInforme.PlanchetaDistribucionParcelariaP]: "Informe de Plancheta Distribución Parcelaria (P)",
  [TipoInforme.ValuacionFiscalP]: "Informe de Valuación Fiscal (P)",
  [TipoInforme.InscripcionOficiosPoC]: "Informe de Inscripción de Oficios (PoC)",
  [TipoInforme.TitularidadDominioCapital]: "Informe de Titularidad Dominio Capital",
  [TipoInforme.ConsultaIndiceTitularesProvinciaFisica]: "Consulta al Índice de Titulares (Física)",
  [TipoInforme.ConsultaIndiceTitularesProvinciaJuridica]: "Consulta al Índice de Titulares (Jurídica)",
  [TipoInforme.CesionProvinciaFisica]: "Informe de Cesión Provincia (Física)",
  [TipoInforme.CesionProvinciaJuridica]: "Informe de Cesión Provincia (Jurídica)",
  [TipoInforme.InformeGeneralInterior]: "Informes del Interior del país",
};

export const informesConsultarPrecio: TipoInforme[] = [
  TipoInforme.TitularidadDominioCapital,
  TipoInforme.EstudioPrefectibilidadCapitalCatastro,
  TipoInforme.EstadoParcelarioCapitalCatastro,
  TipoInforme.EstudioPrefectibilidadProvinciaCatastro,
  TipoInforme.EstadoParcelarioProvinciaCatastro,
  TipoInforme.InscripcionOficiosPoC,
  TipoInforme.Patentamiento,
  TipoInforme.Transferencia,
  TipoInforme.InformeGeneralInterior,
]


export interface IInforme {
  pdfRejected: any;
  printed: boolean;
  domicilios: any;
  nacionalidad: any;
  tipoDocumento: any;
  id: number;
  idCarrito: number;
  tipo: TipoInforme;
  descripcion: string;
  fechaDeCreacion: Date;
  _id: string;
  precio: number;
  velocidad: velocidades;
  estadoGeneral: estadoGeneralInforme;
  expiracionDeRecuperacion: string;
  idCliente: number;
  keyPrecio: string;
  informeEntregadoGobierno: any;
  pdfLiquidacion: any;
  fechaEntregadoGobierno: any;
  archivosAdjuntos: any[];
  liquidado?: boolean;
  usuario?: IUser;
  rejected?: boolean;
  entrada?: any;
  repedido: boolean;
  getName: () => string;
}
export function isIInforme(obj: any): obj is IInforme {
  return obj && typeof obj === 'object' &&
    typeof obj.tipo === 'string'
}


export enum velocidades {
  "PLAZO ÚNICO" = -1, SIMPLE = 1, URGENTE = 2, EXPRESS = 3, "EN EL DÍA" = 4, CERTIFICADA = 5, CAPITAL = 6, PROVINCIA = 7
}

export enum EnumZonas {
  SUD = 1, NORTE
}

export enum EnumTiposDocumento {
  DNI = 1, CEDULA_IDENTIDAD, LIBRETA_ENROLAMIENTO, LIBRETA_CIVICA, PASAPORTE, DOCUMENTO_EXTRANJERO, CEDULA_IDENTIDAD_EXTRANJERO
}

export interface ICarrito {
  observed: boolean;
  pdfObserved: string;
  informes: any[];
  idCarrito: number;
  fechaDeCreacionCarrito: Date;
  usuario: IUser;
  nombreCarrito: string;
  montoTotal: number;
  pagado: boolean;
  estadoGeneral: estadoGeneralCarrito;
  liquidado: boolean;
  pdfLiquidacion: string;
  facturaAdjunta?: string;
  liquidacionMensual?: string;
  observedReason?: string;
}

export function isICarrito(obj: any): obj is ICarrito {
  return obj && typeof obj === 'object' &&
    typeof obj.idCarrito === 'number'
}


export enum estadoGeneralCarrito {
  'Pendiente' = 0,
  'En proceso' = 1,
  'Informada' = 2,
}

export enum estadoGeneralInforme {
  'Pendiente' = 0,
  'En proceso' = 1,
  'Informado' = 2,
}

export interface IPrecio {
  key: string[];
  tipo: TipoInforme;
  tipoInforme: string;
  velocidad: string[];
  precio: number[];
  costo: number[];
  id: number;
  updated_at: Date;
}

export const informesPrecios: Record<string, string> = {
  // Capital (Están todos)
  "BienesPersonalesCapitalFisica": "BienesPersonalesCapital",
  "BienesPersonalesCapitalJuridica": "BienesPersonalesCapital",
  "CopiaDeEscrituraYReglamentos": "CopiaEscrituraReglamentoCapital",
  "DominioCapitalModerno": "DominioCapital",
  "DominioCapitalAntiguo": "DominioCapital",
  "EmpresarialCapitalFisica": "EmpresarialCapital",
  "EmpresarialCapitalJuridica": "EmpresarialCapital",
  "FrecuenciaCapital": "FrecuenciaCapital",
  "InhibicionCapitalFisica": "InhibicionCapital",
  "InhibicionCapitalJuridica": "InhibicionCapital",
  "TitularidadCapital": "TitularidadCapital",
  "TitularidadDominioCapital": "TitularidadDominioCapital",

  // Provincia (Están todos)
  "ConsultaIndiceTitularesProvinciaFisica": "ConsultaIndiceTitularesProvincia",
  "ConsultaIndiceTitularesProvinciaJuridica": "ConsultaIndiceTitularesProvincia",
  "CesionProvinciaFisica": "CesionProvincia",
  "CesionProvinciaJuridica": "CesionProvincia",
  "CopiaDeEscrituraYReglamentosProvincia": "CopiaDeEscrituraYReglamentosProvincia",
  "EmpresarialProvinciaFisica": "EmpresarialProvincia",
  "EmpresarialProvinciaJuridica": "EmpresarialProvincia",
  "FrecuenciaProvincia": "FrecuenciaProvincia",
  "InhibicionProvinciaFisica": "InhibicionProvincia",
  "InhibicionProvinciaJuridica": "InhibicionProvincia",

  // Catastro Capital CopiaDePlanos (Están todas)
  "PlanoObraSanitariaCapitalCatastro": "PlanoObraSanitariaCapital",
  "PlanoMensuraSubdivicionCapital": "PlanoMensuraSubdivicionCapital",

  // Partidas (Están todas)
  "PartidaNacimiento": "PartidaNacimiento",
  "PartidaMatrimonio": "PartidaMatrimonio",
  "PartidaUnionConvivencial": "PartidaUnionConvivencial",
  "PartidaDefuncion": "PartidaDefuncion",

  // Automotor (Están todas)
  "DominioAutomotor": "DominioAutomotor",
  // "InhibicionAutomotor": "InhibicionAutomotor",
  "InhibicionAutomotor": "InhibicionAutomotor",
  "InhibicionAutomotorJuridica": "InhibicionAutomotor",

  // Transferencias (Están todas)
  "Transferencia": "Transferencia",

  // Patentamientos (Están todas)
  "Patentamiento": "Patentamiento",

  // Catastro Capital Plancehta (Están todas)
  "EstadoParcelarioCapitalCatastro": "EstadoParcelarioCapital",
  "EstudioPrefectibilidadCapitalCatastro": "EstudioPrefectibilidadCapital",

  // Catastro Provincia Plancheta (Están todas)
  "EstadoParcelarioProvinciaCatastro": "EstadoParcelarioProvincia",
  "EstudioPrefectibilidadProvinciaCatastro": "EstudioPrefectibilidadProvincia",

  // Informes con nomenclatura catastral Provincia (Están todas)
  "DominioProvinciaMatriculado": "DominioProvinciaMatriculado",
  "DominioProvinciaNoMatriculado": "DominioProvinciaNoMatriculado",

  // Catastro Provincia Plancheta (Están todas)
  "PlanchetaCapital": "PlanchetaCapital",
  "ValuacionFiscalCapital": "ValuacionFiscalCapital",

  // Catastro Provincia CopiaDePlanos (Están todas)
  "PlanoMensuraSubdivicionProvincia": "PlanoMensuraSubdivicionProvincia",
  // Catastro Capital CopiaDePlanos (Están todas)
  "PlanoObraCapital": "PlanoObraCapital",

  // Otros Tramites Servicios Para Abogados (Están todas)
  "CedulaCatastralOtrosTramitesP": "CedulaCatastralOtrosTramitesProvincia",
  "CedulaCatastralProvincia": "CedulaCatastralProvincia",
  "CertificadoCatastralP": "CertificadoCatastralProvincia",
  "PlanchetaDistribucionParcelariaP": "PlanchetaDistribucionParcelariaProvincia",
  "ValuacionFiscalP": "ValuacionFiscalProvincia",
  "InscripcionOficiosPoC": "InscripcionOficiosProvinciaCapital",
  "InformeGeneralInterior": "InformeGeneralInterior",
};